/**
 * Stream Library Service
 *
 * API client for the user's curated streaming library (Qobuz albums & artists).
 */

import { api } from './api';

export interface StreamLibraryItem {
  id: string;
  user_id: string;
  entity_type: 'album' | 'artist';
  entity_id: string;
  title: string | null;
  cover_url: string | null;
  artist_name: string | null;
  source: string;
  sort_order: number;
  added_at: string;
}

export const streamLibraryService = {
  list: async (type?: 'album' | 'artist'): Promise<StreamLibraryItem[]> => {
    const qs = type ? `?type=${type}` : '';
    const res = await api.get(`/api/library/stream${qs}`);
    return res.items || [];
  },

  add: async (item: {
    entity_type: 'album' | 'artist';
    entity_id: string;
    title?: string;
    cover_url?: string;
    artist_name?: string;
    source?: string;
  }): Promise<StreamLibraryItem> => {
    const res = await api.post('/api/library/stream', item);
    return res.item;
  },

  remove: async (id: string): Promise<void> => {
    await api.delete(`/api/library/stream/${id}`);
  },

  reorder: async (items: Array<{ id: string; sort_order: number }>): Promise<void> => {
    await api.patch('/api/library/stream/reorder', { items });
  },

  backfill: async (type?: 'album' | 'artist'): Promise<{ added: number }> => {
    const qs = type ? `?type=${type}` : '';
    const res = await api.post(`/api/library/stream/backfill${qs}`);
    return res;
  },
};
